<template>
  <div class="row">
    <Loader v-if="!resourceLoaded" />
    <div class="col-12" v-if="resourceLoaded" >
      <div class="panel-content-inner">
        <div class="row">
          <table
            id="configuration-table"
            class="superconciergerie-table table table-responsive"
          >
            <thead>
              <tr>
                <th>{{ $t("superconcierge.rentals.rental_name") }}</th>
                <th>{{ $t("superconcierge.rentals.commission") }}</th>
                <th>{{ $t("superconcierge.rentals.base_calculation") }}</th>
                <th>{{ $t("superconcierge.rentals.invoiced_at") }}</th>
                <th>{{ $t("superconcierge.rentals.package_1") }}</th>
                <th>{{ $t("superconcierge.rentals.package_1_invoiced_at") }}</th>
                <th>{{ $t("superconcierge.rentals.package_2") }}</th>
                <th>{{ $t("superconcierge.rentals.package_2_invoiced_at") }}</th>
                <th>{{ $t("superconcierge.rentals.reservation_status") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rental in filteredRentals" :key="rental.id">
                <td>
                  <div>
                    <a
                      class="m-b-10 product-price action-title"
                      :href="'#/rentals/' + rental.id"
                      target="_blank"
                      >{{ rental.name }}
                    </a>
                    <i v-show="!rental.owner" title="Aucun propriétaire défini pour cet hébergement" class="fa fa-exclamation-triangle " style="font-size: 12px;margin-top: 0px;margin-left:5px;color: #ef8a01;"></i>
                  </div>
                </td>
                <td>
                  <div
                    :id="'rental-' + rental.id + '-concierge_commission'"
                    class="cursor-pointer"
                    @click.prevent="
                      showInputField(rental, 'concierge_commission', 'rental-', updateRental, this)
                    "
                  >
                    {{ rental.concierge_commission }}%
                  </div>
                </td>
                <td>
                  <dropdown-selector
                    :id="rental.id"
                    :options="[
                      {
                        id:'total',
                        name: $t('superconcierge.rentals.base_calculation_selection.total')
                      },
                      {
                        id:'net',
                        name: $t('superconcierge.rentals.base_calculation_selection.net')
                      },
                      {
                        id:'net_minus_cleaning',
                        name: $t('superconcierge.rentals.base_calculation_selection.net_minus_cleaning')
                      }
                    ]"
                    :default-selected="rental.concierge_base_calculation"
                    @update:selected="rental.concierge_base_calculation = $event"
                  />
                </td>
                <td>
                  <dropdown-selector
                    :id="rental.id"
                    :options="[
                      {
                        id: null,
                        name: '‎'
                      },
                      {
                        id:'checkin',
                        name: $t('superconcierge.rentals.invoiced_at_selection.checkin')
                      },
                      {
                        id:'checkout',
                        name: $t('superconcierge.rentals.invoiced_at_selection.checkout')
                      },
                      {
                        id:'rolling',
                        name: $t('superconcierge.rentals.invoiced_at_selection.rolling')
                      }
                    ]"
                    :default-selected="rental.concierge_base_calculation_at"
                    @update:selected="rental.concierge_base_calculation_at = $event"
                  />
                </td>
                <td>
                  <dropdown-selector
                    :id="rental.id"
                    :options="[
                      {
                        id:'cleaning',
                        name: $t('superconcierge.rentals.package_selection.cleaning')
                      },
                      {
                        id:'linen',
                        name: $t('superconcierge.rentals.package_selection.linen')
                      },
                      {
                        id:'checkin',
                        name: $t('superconcierge.rentals.package_selection.checkin')
                      }
                    ]"
                    :default-selected="(typeof rental.concierge_package_1 === 'string') ? JSON.parse(rental.concierge_package_1) : []"
                    @update:selected="rental.concierge_package_1 = $event"
                    :multiple="true"
                  />
                </td>
                <td>
                  <dropdown-selector
                    :id="rental.id"
                    :options="[
                      {
                        id: null,
                        name: '‎'
                      },
                      {
                        id:'checkin',
                        name: $t('superconcierge.rentals.invoiced_at_selection.checkin')
                      },
                      {
                        id:'checkout',
                        name: $t('superconcierge.rentals.invoiced_at_selection.checkout')
                      },
                      {
                        id:'rolling',
                        name: $t('superconcierge.rentals.invoiced_at_selection.rolling')
                      }
                    ]"
                    :default-selected="rental.concierge_package_1_at"
                    @update:selected="rental.concierge_package_1_at = $event"
                  />
                </td>
                <td>
                  <dropdown-selector
                    :id="rental.id"
                    :options="[
                      {
                        id:'cleaning',
                        name: $t('superconcierge.rentals.package_selection.cleaning')
                      },
                      {
                        id:'linen',
                        name: $t('superconcierge.rentals.package_selection.linen')
                      },
                      {
                        id:'checkin',
                        name: $t('superconcierge.rentals.package_selection.checkin')
                      }
                    ]"
                    :default-selected="(typeof rental.concierge_package_2 === 'string') ? JSON.parse(rental.concierge_package_2) : []"
                    @update:selected="rental.concierge_package_2 = $event"
                    :multiple="true"
                  />
                </td>
                <td>
                  <dropdown-selector
                    :id="rental.id"
                    :options="[
                      {
                        id: null,
                        name: '‎'
                      },
                      {
                        id:'checkin',
                        name: $t('superconcierge.rentals.invoiced_at_selection.checkin')
                      },
                      {
                        id:'checkout',
                        name: $t('superconcierge.rentals.invoiced_at_selection.checkout')
                      },
                      {
                        id:'rolling',
                        name: $t('superconcierge.rentals.invoiced_at_selection.rolling')
                      }
                    ]"
                    :default-selected="rental.concierge_package_2_at"
                    @update:selected="rental.concierge_package_2_at = $event"
                  />
                </td>
                <td>
                  <dropdown-selector
                    :id="rental.id"
                    :options="[
                      {
                        id:'confirmed',
                        name: $t('superconcierge.rentals.reservation_status_selection.confirmed')
                      },
                      {
                        id:'cancelled',
                        name: $t('superconcierge.rentals.reservation_status_selection.canceled')
                      },
                      {
                        id:'noshow',
                        name: $t('superconcierge.rentals.reservation_status_selection.no_show')
                      }
                    ]"
                    :default-selected="(typeof rental.concierge_status_calculation === 'string') ? JSON.parse(rental.concierge_status_calculation) : []"
                    :multiple="true"
                    @update:selected="rental.concierge_status_calculation = $event"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import rental from '../../../services/rental';
import superconciergerie from "../../../services/superconciergerie";
export default {
  data() {
    return {
      resourceLoaded: false,
      rentals: [],
      filteredRentals: [],
      filteredRentalIds: [],
      owners: [],
      filteredOwners: [],
      filteredOwnerIds: [],
      updateField: null,
      package_1_selected: [],
    };
  },
  methods: {
    async updateRental(rental, field, vm) {
      const rentalId = rental.id;
      if (!document.getElementById("input-" + rentalId + "-" + field)) {
        return;
      }
      let value = document.getElementById(
        "input-" + rentalId + "-" + field
      ).value;

      if (rental[field] != value) {
        rental[field] = parseFloat(value);
        await superconciergerie.updateRental(this, rental);
      }

      document.getElementById("rental-" + rentalId + "-" + field).innerHTML =
        value + "%";
      // document.getElementById("input-"+rentalId+"-"+field).remove();
      vm.updateField = null;
    },
    async loadResource() {
      if (this.activeTab === "configuration" && !this.resourceLoaded) {
        this.resourceLoaded = true;
        await superconciergerie.getRentals(this);

        this.$root.$emit('configuration_rentals_setFilterElems', this.filteredRentals);
        this.$root.$emit('configuration_rentals_setFilterFallback', (ids) => this.filterData(ids, this, "rentals"));

        this.$root.$emit('configuration_owners_setFilterElems', this.filteredOwners);
        this.$root.$emit('configuration_owners_setFilterFallback',(ids) => this.filterData(ids, this, "owners"));

        this.resourceLoaded = true;
      }
    },
    filterData(filteredIds, context, target) {
      if(target === "rentals") {
        context.filteredRentalIds = filteredIds;
      } else {
        context.filteredOwnerIds = filteredIds;
      }

      context.filteredRentals = this.rentals.filter((rental) => {
        const rentalMatch = !context.filteredRentalIds.length || context.filteredRentalIds.includes(rental.id);
        const ownerMatch = !context.filteredOwnerIds.length || (rental.owner && context.filteredOwnerIds.includes(rental.owner.id));

        return rentalMatch && ownerMatch;
      });
    },
    async save() {
      await superconciergerie.updateRentals(this, this.filteredRentals);
    },
  },
  props: ["activeTab", "showInputField"],
  async mounted() {
    await this.loadResource();
  },
  watch: {
    activeTab: async function (val) {
      await this.loadResource();
    },
    rentals: function(val) {
      // filters owners
      this.owners = this.rentals.map(rental => rental.owner);
      this.owners = this.owners.filter(o => o != null);
      this.owners = this.owners.filter((owner, index, self) =>
          index === self.findIndex((t) => (
            t.id === owner.id
          ))
      );
      this.filteredOwners = this.owners;
    }
  },
  components: {
    Loader: require('../components/Loader.vue'),
    DropdownSelector: require('../components/DropdownSelector.vue'),
  },
};
</script>



// WEBPACK FOOTER //
// ConfigurationTab.vue?40e6472e